// annotation.title (px/mx/.../piso/miso/default) を画面表示用ラベルに変換する純粋関数。
// プリセット外の入力は 'Custom' を返す。

const LABEL_MAP: Record<string, string> = {
  px: '+X',
  mx: '-X',
  py: '+Y',
  my: '-Y',
  pz: '+Z',
  mz: '-Z',
  piso: 'Iso+',
  miso: 'Iso-',
  default: 'Default',
};

export const annotationTitleToLabel = (title: string): string => {
  if (!title) return 'Custom';
  return LABEL_MAP[title.toLowerCase()] ?? 'Custom';
};
